import { Model } from '@/models/Model';
export class SkillSet extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'SkillSet';
        this.$endpoint = '/skill-set';
        this.$fillable = [];
    }
}
